import { useContext } from 'react';
import { Typography, Table } from 'antd';
import locale from 'antd/es/locale/pt_BR';

import { ICongelamentosUnicosExtrato } from '../../interfaces';

import { useAbaCongelamentosUnicos } from './useAbaCongelamentosUnicos';
import { GlobalContext } from '../../../../../../contexts/globalContext';

const { Text } = Typography;

interface IProps {
    congelamentos: ICongelamentosUnicosExtrato[];
}

export function AbaCongelamentosUnicos({
    congelamentos,
}: IProps) {

    const {
        refContagemDoFiltro,
        columns,
    } = useAbaCongelamentosUnicos(congelamentos);

    const { theme } = useContext(GlobalContext);

    return (
        <Table
            style={{
            }}
            rowKey={(record) => record.id}
            columns={columns} dataSource={congelamentos}
            scroll={{ x: 650, y: 400 }}
            onChange={
                (pagination, filters, sorter, extra) => {
                    refContagemDoFiltro.current = extra.currentDataSource
                }
            }
            title={(registros) => {
                return (
                    <div
                        style={{
                            backgroundColor: theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                            padding: 10,
                            margin: -8,
                            marginBottom: 0.5
                        }}
                    >
                        <Text>
                            {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                congelamentos.length :
                                refContagemDoFiltro.current.length} num total de ${congelamentos.length} `}
                        </Text>
                    </div>
                )
            }}
            footer={(registros) => {
                return (
                    <div
                        style={{
                            textAlign: 'end'
                        }}
                    >
                        <Text>
                            {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                congelamentos.length :
                                refContagemDoFiltro.current.length} num total de ${congelamentos.length} `}
                        </Text>
                    </div>
                )
            }}
            size="small"
            pagination={{
                locale: { items_per_page: '' },
                showSizeChanger: false,
                defaultPageSize: 100,
                position: [],
                pageSizeOptions: ['10', '20', '50', '100']
            }}
            locale={locale.Table}
        />
    );
}
